export class InventoryBalancesImportModel {
  counter: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  date: Date = new Date;
  providerDocument: string = ""
  storeCode: number = 0;
  articleCode: number = 0;
  quantity: number = 0;
  cost: number = 0;
  constructor(
    counter: number = 0,
    companyId: number = 0,
    branchId: number = 0,
    consecutive: number = 0,
    date: Date = new Date,
    providerDocument: string = "",
    storeCode: number = 0,
    articleCode: number = 0,
    quantity: number = 0,
    cost: number = 0
  ) {
    this.counter = counter;
    this.companyId = companyId;
    this.branchId = branchId;
    this.consecutive = consecutive;
    this.date = date;
    this.providerDocument = providerDocument;
    this.storeCode = storeCode;
    this.articleCode = articleCode;
    this.quantity = quantity;
    this.cost = cost;
  }
}